/**
 * Get Avatar Size Styles Helper
 * Returns size-based style objects for avatar display components
 */

import type { ViewStyle, TextStyle } from 'react-native';

export interface AvatarSizeStyles {
  container: ViewStyle;
  image: ViewStyle;
  ghostText: TextStyle;
}

/**
 * Get size-based styles for avatar display
 * Returns style objects for container, image, and ghost text
 * @param size - Optional size in pixels. If not provided, returns null
 * @returns Style object with container, image, and ghostText styles, or null if size is undefined
 */
export const getAvatarSizeStyles = (size?: number, rounded: boolean = true): AvatarSizeStyles | null => {
  if (!size) return null;
  
  return {
    container: {
      width: size,
      height: size,
      borderRadius: rounded ? size / 2 : 0,
      /** Circle clips corners — crops wide/full-body art. Square VS row uses rounded=false + visible overflow. */
      overflow: rounded ? 'hidden' : 'visible',
    },
    image: {
      width: size,
      height: size,
    },
    ghostText: {
      fontSize: Math.max(12, size * 0.5),
    },
  };
};







